<template>
  <img class="BaseBg" :src="bgImgUrl">
</template>

<script>
export default {
  name: 'BaseBgLt',
  data() {
    return {}
  },
  props: {
    bgImgUrl: {
      type: String
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  components: {},
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.BaseBg {
  position: fixed;
  top: 0;
  left: 0;
  // z-index: 10;
  pointer-events: none;

  width: 100%;
  height: 100%;
}
</style>